<template>
  <r-panel :disabled="disabled" :title="title" :button_add="true" @click_add="click_add">
    <r-plinko-obstacle-config-table ref="table" :items.sync="_items" :toolbar="false" :title="title"/>
  </r-panel>
</template>
<script>

import VueTypes from "vue-types";
import {PlinkoObstacleConfig} from "@/modules/redactor/models/smart-offer/bundle-plinko/PlinkoObstacleConfig";

import RPanel from "@/modules/redactor/views/utils/r-panel.vue";
import RPlinkoObstacleConfigTable from "@/modules/redactor/views/smart-offer/bundle-plinko/r-plinko-obstacle-config-table.vue";

export default {
  name: "r-plinko-obstacle-config-panel",
  components: {RPlinkoObstacleConfigTable, RPanel},
  props: {
    disabled: VueTypes.bool.def(false),
    title: VueTypes.string.def("Obstacles"),
    items: VueTypes.arrayOf(PlinkoObstacleConfig)
  },
  computed: {
    _items() {
      if (this.items) {
        return this.items;
      } else {
        let values = [];
        this.$emit("update:items", values);
        return values;
      }
    }
  },
  methods: {
    click_add() {
      this.$refs["table"].row_create();
    }
  }
}

</script>